<template lang="pug">
  v-input(v-bind="$attrs" v-on="$listeners")
    v-card(flat color="grey lighten-3").sdo-radius.fill-width
      v-card-text
        .mb-3(
          v-if="differenceHHMM"
        )
          div
            v-icon(left) mdi-clock-outline
            span(v-if="differenceHHMM.h > 0") {{ $tc('hours', differenceHHMM.h) }}
            span(v-if="differenceHHMM.m > 0")  {{ $tc('minutes', differenceHHMM.m) }}
          .caption {{ label }}
        .mb-3(v-else) {{ label }}

        v-row(
          align="center"
          no-gutters
        )
          .title.mr-4.shrink c
          sdo-datetime-field(
            :value="value && value.start"
            outlined
            only-time
            :time-props="timeProps"
            hide-details
            @input="inputValue('start', $event)"
          ).grow
          .title.mx-4.shrink по
          sdo-datetime-field(
            :value="value && value.end"
            outlined
            only-time
            :time-props="timeProps"
            hide-details
            @input="inputValue('end', $event)"
          ).grow
</template>

<script>
import { differenceInMinutes, parse } from 'date-fns';

export default {
  props: {
    // value - ({ start: null, end: null, duration: null })
    value: { type: Object, default: null },
    label: { type: String, default: 'Продолжительность' },
  },
  computed: {
    timeProps() {
      return {
        outlined: true,
        rounded: true,
        color: 'secondary',
      };
    },
    differenceMinutes() {
      if (this.value?.start && this.value?.end) {
        const start = parse(this.value.start, 'HH:mm', new Date());
        const end = parse(this.value.end, 'HH:mm', new Date());
        const minutes = differenceInMinutes(end, start);
        if (minutes < 0) {
          return 1440 + minutes;
        }
        return minutes;
      }
      return null;
    },
    differenceHHMM() {
      if (this.differenceMinutes) {
        const m = this.differenceMinutes % 60;
        const h = (this.differenceMinutes - m) / 60;
        return { h, m };
      }
      return null;
    },
  },
  methods: {
    inputValue(key, value) {
      this.$emit('input', {
        ...this.value,
        duration: this.differenceMinutes,
        [key]: value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-datetime-field__time {
    width: 100%;
  }
}
</style>
